<template>
  <div id="eventLineManagerDiv">
    <select :size="10" id="eventLineSelect" ref="eventLineSelect" @change="selectChange" multiple>
      <option v-for="(item, index) in orderedEventLines" :key="index">{{ item.time }}</option>
    </select>
    <div id="eventLineDetails">
      <button @click="jumpEventLine">jump to selected event line</button><br>
      <button @click="addEventLine">add new event line</button><br>
      <button @click="removeEventLine">remove selected event lines</button><br>
      <hr>
      <div v-if="selectedEventLines != null && selectedEventLines.length > 0">
        <select :value="selectedParameters[0].type" @change="e => setParameter('type', e.target.value)">
          <option v-for="[k, v] in Object.entries(EventLineType)" :key="k" :value="v">{{ k }}</option>
        </select>
        <div style="display: flex; justify-content: space-between; width: 100%;">
          time: <input type="number" step="0.001" :value="selectedParameters[0].time"
            @input="e => setParameter('time', e.target.valueAsNumber)" />
        </div>
        <div style="display: flex; justify-content: space-between; width: 100%;">
          frame: <input type="number" step="0.001" :value="selectedParameters[0].time * 60"
            @input="e => setParameter('time', e.target.valueAsNumber / 60)" />
        </div>
        <div v-if="selectedParameters[0].type === EventLineType.Timing"
          style="display: flex; justify-content: space-between; width: 100%;">
          bpm: <input type="number" step="1" :value="selectedParameters[0].bpm"
            @input="e => setParameter('bpm', e.target.valueAsNumber)" />
        </div>
        <div style="display: flex; justify-content: space-between; width: 100%;">
          thickness: <input type="number" step="1" min="0" :value="selectedParameters[0].thickness"
            @input="e => setParameter('thickness', e.target.valueAsNumber)" />
        </div>
        <div style="display: flex; justify-content: space-between; width: 100%;">
          colour: <input type="color" :value="selectedParameters[0].colour"
            @input="e => setParameter('colour', e.target.value)" />
        </div>
        <div id="eventLineParameterManagerDiv">
          <div v-for="[key, value] in Object.entries(selectedParameters[1])" :key="key"
            style="display: flex; justify-content: space-between; width: 100%; ">
            <button @click="removeParameter(key)">x</button>
            {{ key }} :
            <input type="text" @input="e => setParameter(key, e.target.value)" :value="value" />
          </div>
          <div>
            <input type="text" ref="newKeyTxtBox" />
            <button @click="addParameter()">add key</button>
          </div>
        </div>
      </div>
      <div v-else>no event line selected</div>
    </div>
  </div>
</template>

<script setup>
import { computed, inject, ref, shallowRef, triggerRef, useTemplateRef } from 'vue';
import { useAudioStore } from '../../stores/AudioStore';
import { useSelectionStore } from '../../stores/SelectionStore';
import { useLogStore } from '../../stores/LogStore';
import { commonAttributes } from '@/util/utilFunctions';
import { EventLineType } from '@/util/constants';

const mainChart = inject('mainChart')
const { orderedEventLines } = mainChart

const mainChartRender = inject('mainChartRender')
const { currentTime } = mainChartRender

const audioStore = useAudioStore()

const logStore = useLogStore()
const LOG_GROUP = "Event Lines"

// details
const selectedEventLines = shallowRef([])

const selectedParameters = computed(() => {
  const cAttrs = commonAttributes(selectedEventLines.value)
  const { eventLineId, time, bpm, thickness, colour, type, ...others } = cAttrs
  if (type === EventLineType.Timing)
    return [{ time, bpm, thickness, colour, type }, others]
  else
    return [{ time, thickness, colour, type }, {bpm, ...others}]
})

// actions / selection
const selectChange = e => {
  selectedEventLines.value = Array.from(e.target.selectedOptions).map(e => orderedEventLines.value[e.index])
}

const jumpEventLine = () => {
  if (selectedEventLines.value.length > 0) {
    if (audioStore.hasAudioLoaded)
      audioStore.seek(selectedEventLines.value[0].time)
    else
      currentTime.value = selectedEventLines.value[0].time
  }
}

const addEventLine = () => {
  mainChart.addEventLine(currentTime.value)
  logStore.sendLog(LOG_GROUP, `Created new event line at ${currentTime.value}`)
}

const removeEventLine = () => {
  if (!confirm(`remove event lines of times: ${selectedEventLines.value.map(e => e.time).join(', ')} ?`)) return


  selectedEventLines.value.forEach(e => {
    mainChart.removeEventLine(e.eventLineId)
    logStore.sendLog(LOG_GROUP, `Removed event line at time ${e.time}, bpm ${e.bpm}`)
  })
  selectedEventLines.value = []
}

// actions / parameters
const newKeyTxtBox = useTemplateRef("newKeyTxtBox")
const addParameter = () => {
  let key = newKeyTxtBox.value.value
  if (key == "frame") key = "time"
  selectedEventLines.value.forEach(x => {
    mainChart.setEventLineParameter(x.eventLineId, key, "")
  })
}

const removeParameter = (key) => {
  selectedEventLines.value.forEach(x => {
    mainChart.setEventLineParameter(x.eventLineId, key, null)
  })
}

const setParameter = (key, value) => {
  selectedEventLines.value.forEach(x => {
    mainChart.setEventLineParameter(x.eventLineId, key, value)
  })
  triggerRef(selectedEventLines)
}


</script>

<style scoped>
#eventLineManagerDiv {
  display: flex;
}

#eventLineSelect {
  width: 100px
}

#eventLineDetails {
  display: block;
}

#eventLineParameterManagerDiv>input {
  width: 100%;
}
</style>